
import SubmittingLogInForm from '../Registration/UsersValidation';



function Login() {

         
    return (
        <div className="app">
            <div className="login-form">         
                <SubmittingLogInForm />    
            </div>
        </div>
    );
    }

export default Login;

